export enum ESocialMedia {
    Github = "Github", 
    LinkedIn = "LinkedIn",
    Instagram = "Instagram",
    Twitter = "Twitter",
    Twitch = "Twitch"
}